import React, { useEffect, useState } from "react";
import { Container, Row, Col, Breadcrumb, Card } from "react-bootstrap";
import Topnav from "../common/Topnav";
import { Link } from "react-router-dom";
import Footer from "../common/Footer";
import bannerImage from "../../Images/Banner/Gov-body.webp";
const PrivacyPolicy = () => {
  const [modalShow, setModalShow] = React.useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <title>Privacy Policy | ISBM Unversity | Visit Now</title>
      <meta
        name="description"
        content="ISBM University's Privacy Policy to understand how we protect your data. Learn about our secure practices & user privacy. Stay informed & safe online"
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="conatiner-xxl">
            <div className="section-hero-content">
              <h1>Privacy Policy</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Privacy Policy
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      {/* container */}
      <section className="container-xxl ptb-50">
        <Row>
          <Col lg={12} className="m-auto">
            <h2 className="modern-title section-title-start text-blue">
              Privacy Policy
            </h2>

            <Row className="g-3">
              <div className="col-12">
                <Card className="p-4 shadow-lg h-100 edge-box border-0 rounded-5">
                  <h3>Commitment to Privacy</h3>
                  <p>
                    ISBM University Privacy Policy outlines the commitment for protecting the
                    personal information of its students, members of the faculty, staff, and
                    other stakeholders. This policy ensures that all personal data is collected,
                    stored, and processed in compliance with applicable data protection
                    regulations. The University recognizes the importance of privacy and is
                    dedicated to safeguard sensitive information such as names, addresses,
                    identification numbers, academic records, financial details, employment
                    details, and any other personal identifiers.
                  </p>
                  <p>
                    The collection of personal data is limited to the extent necessary for
                    academic, administrative, and operational purposes. The University employs
                    strict security measures to prevent unauthorized access, alteration, or
                    disclosure of personal information. Personal information may be shared with
                    third parties, such as Government authorities or service providers, only
                    when legally required or with explicit consent.
                  </p>
                  <p>
                    The University regularly reviews and updates its Privacy Policy to align
                    with changing regulations and technological advancements, ensuring continued
                    compliance with legal standards and maintaining the trust of its community.
                  </p>
                </Card>
              </div>

              <div className="col-lg-6">
                <Card className="p-4 shadow-lg h-100 edge-box border-0 rounded-5">
                  <h3>Website Use</h3>
                  <p>
                    One can visit our website{" "}
                    <a href="https://isbmuniversity.edu.in" target="_blank" rel="noreferrer">
                      isbmuniversity.edu.in
                    </a>{" "}
                    without revealing any personal information wherever permissible. Certain
                    transactions are required for the submission of personal information like
                    profile updates and certain databases. We will not sell, swap or rent, or
                    otherwise disclose to any third party any personal information for
                    commercial purpose and such information will be utilized only for the
                    purpose stated.
                  </p>
                  <p>
                    To accomplish such purposes, we may disclose the information to our
                    employees, consultants, and other concerned parties having a genuine need
                    to know the information.
                  </p>
                </Card>
              </div>

              <div className="col-lg-6">
                <Card className="p-4 shadow-lg h-100 edge-box border-0 rounded-5">
                  <h3>Personal Data Collection</h3>
                  <p>
                    When you engage with our platform, we may collect and store the personal
                    information you provide. This information helps us tailor our services and
                    enhance your experience. You can explore certain areas without revealing
                    your identity, but once you voluntarily provide details like your name,
                    contact information, or payment details, you will no longer be anonymous to
                    us.
                  </p>
                </Card>
              </div>

              <div className="col-lg-6">
                <Card className="p-4 shadow-lg h-100 edge-box border-0 rounded-5">
                  <h3>Information Logging</h3>
                  <p>
                    Our web server may record the Internet Protocol (IP) address of the device
                    you are using, browser and operating system information, date and time of
                    access, and the referring page. This information may be used to administer
                    and improve our website and generate aggregate statistical reports.
                  </p>
                </Card>
              </div>

              <div className="col-lg-6">
                <Card className="p-4 shadow-lg h-100 edge-box border-0 rounded-5">
                  <h3>Cookies & Tracking</h3>
                  <p>
                    We may use cookies, pixels, or transparent GIF files to track session
                    information and deliver customizable services. Such information is anonymous
                    and not personally identifiable. While we make our best efforts to protect
                    the privacy of users, we cannot ensure the security of any information
                    transmitted to us, and you do so at your own risk.
                  </p>
                </Card>
              </div>

              <div className="col-12">
                <Card className="p-4 shadow-lg h-100 edge-box border-0 rounded-5">
                  <h3>Policy Changes</h3>
                  <p>
                    This Privacy Policy may be revised, modified, or amended at any time at the
                    sole discretion of the University.
                  </p>
                </Card>
              </div>
            </Row>
          </Col>
        </Row>
      </section>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
